var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6897 15.9902C22.5677 15.8787 22.3888 15.8569 22.2431 15.9338C18.0719 18.1461 12.9527 16.6746 10.5908 12.5834C8.22878 8.4922 9.5133 3.32382 13.5152 0.816947C13.6551 0.729486 13.7249 0.563257 13.6893 0.402296C13.654 0.241073 13.5212 0.119365 13.3576 0.0985529C10.7646 -0.234696 8.19691 0.280852 5.93055 1.58961C3.18922 3.17155 1.2282 5.72742 0.408905 8.78514C-0.410386 11.8429 0.0100606 15.0365 1.59306 17.7781C3.17579 20.5197 5.7314 22.4807 8.78911 23.3C9.8102 23.5735 10.8463 23.7089 11.8758 23.7089C13.9293 23.7089 15.9562 23.1704 17.7821 22.1161C20.0479 20.8079 21.7787 18.8416 22.7866 16.4296C22.8504 16.2773 22.8114 16.1016 22.6897 15.9902Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.61091c0b1db29aa56ea6f39d16d6a683.svg";
export { ForwardRef as ReactComponent };